import React from "react";
import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { communitiesAPI } from "../services/api";
import {
  buildDiscoverCommunitiesNavigationState,
  mergeDiscoverRouteCache,
} from "../utils/discoverRouteCache";
import "./NavigationButtons.css";

const DiscoverButton = ({
  title = "Discover Communities",
  disabled = false,
  className = "nav-button nav-button-discover",
}) => {
  const navigate = useNavigate();

  const handleClick = async (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const cachedState = buildDiscoverCommunitiesNavigationState();
    if (cachedState) {
      navigate("/discover-communities", { state: cachedState });
      return;
    }

    try {
      const response = await communitiesAPI.getDiscover();
      const discoverCommunities = response.data.communities || [];
      mergeDiscoverRouteCache({ discoverCommunities });
      navigate("/discover-communities", {
        state: { prefetchedDiscoverCommunities: discoverCommunities },
      });
      return;
    } catch {
      // Navigation should still work if the optimization fetch fails.
    }

    navigate("/discover-communities", {
      state: cachedState,
    });
  };

  return (
    <button
      className={className}
      onClick={disabled ? undefined : handleClick}
      title={title}
      aria-label={title}
      type="button"
      disabled={disabled}
    >
      <Compass size={18} strokeWidth={2} />
    </button>
  );
};

export default DiscoverButton;
